<template>
  <el-container>
    <el-main>
      <h3>品牌联盟的初衷</h3>
      <p>近年来，国内石材行业的发展可谓是坎坷不平，各大石材企业也在政府“转型驱动、创新发展”的号召下进行了业态的调整以及商业模式上的创新，然而在瞬息万变的市场竞争中，一个人或一家企业的力量则显得有些势单力孤，因此，为了扩大市场环境，获取足够的市场份额，我们应转变目前企业“各自为政”的传统销售模式，整合行业的优势资源，打造品牌联盟，以联盟的形式实现由单兵作战走向集团化作战，在建立长期合作关系，创建优势团队，共同运作，互利共赢的同时，逐步提升自身的品牌知名度、品牌影响力以及企业的业绩与产品的销量。品牌联盟将成为企业与消费者双向统一、有序、高效的交流互动平台。</p>
      <div class="img-box">
        <img src="/static/img/banner3.jpg" alt="company-concept">
      </div>
      <h3>品牌联盟的定义</h3>
      <p>品牌联盟”是由东华环球石文化产业园发起，邀请园区内合作力强，产品资源好，服务意识强的商户共同组成，实现资源互通、利益共享、风险共担的共同体。</p>
      <h3>品牌联盟的功能</h3>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'BrandIntroduce'
}
</script>

<style scoped>
.el-main {
  padding: 0;
}
.img-box img {
  width: 100%;
}
.el-main p {
  line-height: 1.5;
  font-size: 1rem;
  text-indent: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/alliancepage/components/BrandIntroduce.vue